/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsNpm: {
  name: 'npm';
  data: string;
} = {
  name: 'npm',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5Zm11 16v-9a1 1 0 1 0-2 0v9H5V5h14v14h-3Z" fill="currentColor"/></svg>`,
};
